import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { MBSeparator } from '@shared/components/list';
import { Colors } from '@shared/styles';
import { i18n } from '@shared/util/i18n';

export function MBChatReadMarker() {
  return (
    <View row center padding={1}>
      <View flex>
        <MBSeparator color={Colors.v2.red} />
      </View>
      <View paddingHorizontal={1}>
        <Text size="body2" color={Colors.v2.red}>
          {/* count > 1 selects the plural "New Messages" form */}
          {i18n('chat.newMessages', { count: 2 })}
        </Text>
      </View>
      <View flex>
        <MBSeparator color={Colors.v2.red} />
      </View>
    </View>
  );
}
